import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ViewToolbarDivider() {
  return /*#__PURE__*/_jsx(View, {
    marginInlineEnd: "400",
    inlineSize: "1px",
    blockSize: "30px",
    backgroundColor: "fill-tertiary-default"
  });
}